








































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  PartnersApi, Partner, MarketsApi, UnitsApi, UnitSchedule,
} from '@compassdigital/foodworks.ts.sdk';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import Schedule from '@/components/Form/ScheduleSetting/Schedule/index.vue';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import { cloneDeep } from 'lodash';
import AccountActivation from '@/components/AccountActivation/index.vue';
import ToastModule from '@/store/modules/toast';
import Service from '@/util/ServiceUtil';

@Component({
  components: {
    StandardCard,
    Schedule,
    AccountActivation,
  },
})
export default class ScheduleSetting extends Vue {
  @Prop({}) unitID!: string;

  @PropSync('marketUserID', {}) marketID!: string;

  @Prop({}) unitUserInfo!: Object;

  @Prop({}) scoutUserInfo!: Object;

  private activationLoader: boolean = false;

  private saving: boolean = false;

  public scheduleUnit: any = {};

  public scheduleUnitOG: any = {};

  public isObject: any = '';

  public mounted() {
    this.getScheduleUnits();
  }

  public async getScheduleUnits() {
    try {
      const api = new UnitsApi(AppModule.apiConfig);
      const fetchedUnit = await api.getUnitById(this.unitID);
      const { schedule } = fetchedUnit.data;
      this.scheduleUnit = schedule;
      this.scheduleUnitOG = cloneDeep(schedule);
      this.isObject = Object.keys(this.scheduleUnit).length;
    } catch (error) {
      console.log('error', error);
    }
  }

  // common pending email account activation
  public async sendInvitation(userEmail: string, userProfile: string) {
    if (userProfile === 'unitmanager') {
      this.activationLoader = true;
    }
    if (userProfile === 'fwmanager') {
      this.saving = true;
    }
    const user: any = await Service.sendInvitation(userEmail);
    if (user.status === 200) {
      ToastModule.setToast({
        message: 'Sign up invitation has been sent',
        timeout: 5000,
      });
    } else {
      ToastModule.setToast({
        message: user.errorMessage,
        timeout: 5000,
      });
    }
    if (userProfile === 'unitmanager') {
      this.activationLoader = false;
    }
    this.saving = false;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
